package presentation.screens.business.inventory.product.create.component

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import common.asset.ImageAsset
import component.input.CustomTextField
import feature.product.viewModel.ProductViewModel

@Composable
fun CreateProductTax(viewModel: ProductViewModel) {
    val product = viewModel.newProduct.collectAsState()
    val nameErrorState = remember { mutableStateOf(false) }
    val salePriceErrorState = remember { mutableStateOf(false) }

    LazyColumn {
        item {
            Column(
                modifier = Modifier.fillMaxWidth().padding(bottom = 10.dp)
            ) {
                CustomTextField(
                    value = product.value?.ProductPrice?.SGST?.toString() ?: "",
                    placeholder = "SGST",
                    trailingIcon = ImageAsset.person,
                    label = "SGST",
                    errorState = nameErrorState.value,
                    keyboardType = KeyboardType.Number,
                    visualTransformation = VisualTransformation.None
                ) { newValue ->
                    viewModel.setNewProductSGST(newValue.text)
                }
                CustomTextField(
                    value = product.value?.ProductPrice?.CGST?.toString() ?: "",
                    placeholder = "CGST",
                    trailingIcon = ImageAsset.person,
                    label = "CGST",
                    errorState = nameErrorState.value,
                    keyboardType = KeyboardType.Number,
                    visualTransformation = VisualTransformation.None
                ) { newValue ->
                    viewModel.setNewProductCGST(newValue.text)
                }
                CustomTextField(
                    value = product.value?.ProductPrice?.IGST?.toString() ?: "",
                    placeholder = "IGST",
                    trailingIcon = ImageAsset.person,
                    label = "IGST",
                    errorState = nameErrorState.value,
                    keyboardType = KeyboardType.Number,
                    visualTransformation = VisualTransformation.None
                ) { newValue ->
                    viewModel.setNewProductIGST(newValue.text)
                }
                CustomTextField(
                    value = product.value?.ProductPrice?.CESS?.toString() ?: "",
                    placeholder = "CESS",
                    trailingIcon = ImageAsset.person,
                    label = "CESS",
                    errorState = nameErrorState.value,
                    keyboardType = KeyboardType.Number,
                    visualTransformation = VisualTransformation.None
                ) { newValue ->
                    viewModel.setNewProductCESS(newValue.text)
                }
                CustomTextField(
                    value = product.value?.ProductPrice?.VAT?.toString() ?: "",
                    placeholder = "VAT",
                    trailingIcon = ImageAsset.person,
                    label = "VAT",
                    errorState = nameErrorState.value,
                    keyboardType = KeyboardType.Number,
                    visualTransformation = VisualTransformation.None
                ) { newValue ->
                    viewModel.setNewProductVAT(newValue.text)
                }
                CustomTextField(
                    value = product.value?.ProductPrice?.OtherTax?.toString() ?: "",
                    placeholder = "OtherTax",
                    trailingIcon = ImageAsset.person,
                    label = "OtherTax",
                    errorState = nameErrorState.value,
                    keyboardType = KeyboardType.Number,
                    visualTransformation = VisualTransformation.None
                ) { newValue ->
                    viewModel.setNewProductOtherTax(newValue.text)
                }
            }
        }
    }
}
